// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2-oHR","rootMobile":"styles_rootMobile__3PaTW"};